import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModal, NgbModalConfig, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxPaginationModule } from 'ngx-pagination';
import { SampleSearchPipe } from '../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../shared/loading/loading.component';
import { RetraitService } from '../../../../core/services/retrait.service';
import { ToastrService } from 'ngx-toastr';
import { AppActionCheck } from '../../../../core/utils/app-action-check';
import { AppErrorShow } from '../../../../core/utils/app-error-show';
import { AppSweetAlert } from '../../../../core/utils/app-sweet-alert';
import { LocalStorageService } from '../../../../core/utils/local-stoarge-service';
import { StatusComponent } from '../../component/status/status.component';

@Component({
  selector: 'app-retrait',
  standalone: true,
  imports: [
     CommonModule,
                FormsModule,
                NgbModule,
                NgxPaginationModule,
                LoadingComponent,
                SampleSearchPipe,
                StatusComponent
  ],
  templateUrl: './retrait.component.html',
  styleUrl: './retrait.component.css'
})
export class RetraitComponent {
 buttonsPermission :any|undefined;
  structures:any[] =[]
  roles:any[] =[]
  data:any[] =[]
  windows:any[] =[]
  selectedWindow:any
  selected_data:any;
  modalOption:any; 
  isDtInitialized:boolean = false
  is_active=null
  loading=false
  tag="Retrait"
  permissionName=""
    search_text=""
role:any
  user:any
  loading2=false
pg={
    pageSize:10,
    p:0,
    total:0
  }


  constructor(
    private withdrawalService:RetraitService,
    private toastrService:ToastrService,
      config: NgbModalConfig,
      private lsService:LocalStorageService,
    private modalService: NgbModal) {
     config.backdrop = 'static';
     config.keyboard = false;
     }


  ngOnInit(): void {
    this.init()
    this.getActions()
  }

  init(){
    this.getAll()
  
  }

 

  getAll(){
    this.loading2=true

    this.withdrawalService.getAll().subscribe((res:any)=>{
      this.data=res.data 
this.pg.pageSize=10
 this.pg.p=0
 this.pg.total=res.data.length
      this.modalService.dismissAll()
      this.loading2=false

    },
    (err:any)=>{
      this.loading2=false
      AppErrorShow.showError("Gestion des rôles",err)

    })
  }


  store(value:any){
    this.loading=true
    this.withdrawalService.store(value).subscribe((res:any)=>{
      this.loading=false
      this.toastrService.success(res.message)
      this.getAll()

    },
    (err:any)=>{
      this.loading=false

      console.log(err)
      AppErrorShow.showError("Gestion des retraits",err)
    })
  }
  update(value:any){
    this.loading=true

    this.withdrawalService.treatment(this.selected_data.id,value).subscribe((res:any)=>{
      this.loading=false

        this.toastrService.success(res.message)
        this.getAll()
    },
    (err:any)=>{
      this.loading=false

      console.log(err)
      AppErrorShow.showError("Gestion des rôles",err)
    })
  }
  delete(){
    if(!this.verifyIfElementChecked()) return ;
    let confirmed=AppSweetAlert.confirmBox('info','Suppression','Voulez vous vraiment retirer cet élément?',);
    confirmed.then((result:any)=>{
       if (result.isConfirmed) {
    this.withdrawalService.delete(this.selected_data.id).subscribe((res:any)=>{
        this.toastrService.success(res.message)
        this.getAll()
    },
    (err:any)=>{
      console.log(err)
      AppErrorShow.showError("Gestion des rôles",err)
    })
  }
})
  }
  checked(el?:any){
    this.selected_data=el;
    this.is_active=el.is_active
  }
  verifyIfElementChecked(){
    console.log(this.selected_data)
    if (this.selected_data==null) {
      this.toastrService.warning("Aucun élément selectionné");
      return false;
    }
    return true;
  }



  dismiss(){
    this.modalService.dismissAll()
  }

  add(content:any){
    this.modalService.open(content,{size:'lg'});
  }


  show(content:any){
    if(!this.verifyIfElementChecked()) return ;
    this.modalOption={centered:false,size:"lg"}
    this.modalService.open(content,{size:'lg'});
  }

  edit(content:any){
    if(!this.verifyIfElementChecked()) return ;
    this.modalService.open(content,{size:'lg'});

  }


  getActions(){
    this.buttonsPermission = {
      show:AppActionCheck.check(this.tag,'Consulter'),
      add:AppActionCheck.check(this.tag,'Ajouter'),
     // edit:AppActionCheck.check(this.tag,'Editer'),
      edit:true,
      delete:AppActionCheck.check(this.tag,'Supprimer'),
      status:AppActionCheck.check(this.tag,'Mettre un statut'),
      print:AppActionCheck.check(this.tag,'Imprimer/Télécharger'),
      transUp:AppActionCheck.check(this.tag,'Transmettre'),
      transDown:AppActionCheck.check(this.tag,'Affecter'),
      sign:AppActionCheck.check(this.tag,'Signer'),
      viewer:AppActionCheck.check(this.tag,'Visualiser Fichier'),
      return:AppActionCheck.check(this.tag,'Retouner pour correction')
    };
  }

  setName(ev:any){
    this.permissionName=this.windows[ev.target.value].name
    this.selectedWindow=this.windows[ev.target.value]
  }

  setValue(i:any){
    this.roles[i].value= !this.roles[i].value
  }

  getJson(actions:any){
    return JSON.parse(actions)
  }

  getPage(event:any){
    this.pg.p=event
  }
}
